// Utils
import { isTaskList } from '../../../../common/elements/utils/elementTypeUtils';
import { getShowTitle } from '../../taskList/taskListSelector';

export default (props, monitor) => {
    const { draggedElements } = monitor.getItem();

    return draggedElements && draggedElements.every((el) => isTaskList(el) && !getShowTitle(el));
};
